/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CancelAction/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'



/** @type {import('Simple/types.js').View} */
export default function CancelAction({
  children,
  viewPath = "/App/ChooseLocation/Support/CancelAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let authApiRoleValueData = fromData.useDataValue({ viewPath,
context: 'auth',
path: 'api_role',
})
let constantData = 'app-admin-xid'
let aggregateData = fromAggregate.equals(authApiRoleValueData, constantData)
  return (<React.Fragment
>
<TysiaModalFooterAction
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 type="secondary"
 text="Cancel"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../../Account'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../../Account'))}
 data="auth.api_role"
 data="'app-admin-xid'"
 aggregate="/Simple/Data/aggregate.js equals"
 disabled={aggregateData}
/>
{children}
</React.Fragment>)
}